export default "__VITE_ASSET__o$heiHGP__"